// Stub for notification service - replace with actual implementation
export const notificationService = {
  getNotifications: async () => [],
  markAsRead: async (_id: string) => true,
  markAllAsRead: async () => true,
  subscribe: (_callback: (notification: any) => void) => () => {},
  add: (notification: any) => {
    console.log('Notification added:', notification);
    return Date.now().toString();
  },
  playNotificationSound: () => {
    console.log('Playing notification sound');
  },
  showBrowserNotification: (title: string, options?: any) => {
    console.log('Browser notification:', title, options);
  }
};
